import { z } from 'zod';
import { FlowDataSchema } from './flowData.js';
import { FlowDefinitionState } from './flowDefinition.js';
import { FlowAgentCreateValuesSchema } from '../agent/agent.js';
import { FlowKind } from '../flow/enums.js';
import { FlowPricingMode } from '../flow/pricingMode.js';
import { FlowTagInputsSchema } from '../flow/tags.js';
const CreateFlowDefinitionSharedShape = {
    name: z.string().describe('Name of the flow to create the definition under.'),
    organizationId: z.uuid().describe('Organization owning the flow.').optional(),
    state: z.enum(FlowDefinitionState).optional().default(FlowDefinitionState.Draft),
    data: FlowDataSchema.describe('The block graph the definition executes.'),
    description: z.string().optional(),
    notes: z.string().optional(),
    documentationMarkdown: z.string().nullish(),
    clonedFromFlowId: z.uuid().describe('Flow this definition was copied from.').nullish(),
    tags: FlowTagInputsSchema.nullish(),
    pricingMode: z.enum(FlowPricingMode).optional(),
};
/**
 * Body `POST /flow-definitions` accepts. Structural validation only: flow-api additionally checks
 * that the name is free within the organization and that the graph's database references resolve,
 * both of which need the database and so cannot live here.
 *
 * A Skill belongs to an organization directly; every other kind belongs to an agent, named either
 * by id or by the values to create it with.
 */
export const CreateFlowDefinitionBodySchema = z.union([
    z
        .object({
        ...CreateFlowDefinitionSharedShape,
        kind: z.literal(FlowKind.Skill),
        agentId: z.null(),
        organizationId: z.uuid().describe('Organization owning the Skill. Required for Skills.'),
    })
        .strict(),
    z
        .object({
        ...CreateFlowDefinitionSharedShape,
        kind: z.literal(FlowKind.Base).optional(),
        agentId: z.uuid().describe('Existing agent to create the flow under.'),
    })
        .strict(),
    z
        .object({
        ...CreateFlowDefinitionSharedShape,
        kind: z.literal(FlowKind.Base).optional(),
        agent: FlowAgentCreateValuesSchema.describe('Agent to create alongside the flow.'),
    })
        .strict(),
]);
//# sourceMappingURL=createRequest.js.map